<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">{{$t('components.partners.divideTheProfitsOfThePartners')}}</h4>
        <router-link
          :to="'/partnersProfits/create?partner_id=' + $route.params.id"
          class="btn btn-sm btn-primary"
        >
          <i class="fas fa-plus"></i> {{$t('components.partners.addition')}}
        </router-link>
      </div>
      <indexTable
        :searchText="$t('components.partners.SearchForAProcess')"
        :emptyTableText="$t('components.partners.ThereAreNoProfitSplitsAtTheMoment')"
        :filter="{partner_id: $route.params.id}"
        :emptyTableSubText="$t('components.partners.TryAddingSomeAndTryAgain')"
        :withoutCard="true"
        :cloumns="[
          { column: 'code', title: $t('components.partners.reference'), type: 'mainLink', sort: true },
          {
            column: 'safe_id',
            title: $t('components.partners.Project'),
            type: 'link',
            to: 'project',
            sort: true,
            link: true,
          },
          { column: 'date', title: $t('components.partners.date'), type: 'text', sort: true },
          { column: 'total', title: $t('components.partners.theAmount'), type: 'text', sort: true },
          {
            column: 'description',
            title: $t('components.partners.thatAbout'),
            type: 'text',
            sort: true,
          },
          {
            column: 'options',
            title: $t('components.partners.actions'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role:
                  $user.admin ||
                  $user.role.safes_deposits_edit,
              },
              {
                name: 'delete',
                role:
                  $user.admin ||
                  $user.role.safes_deposits_delete,
              },
            ],
          },
        ]"
        :deleteText="{
          attention: $t('allerts.Attention'),
          areYouReallySureToDeleteTheItem:
            $t('allerts.areYouReallySureToDeleteTheItem'),
          close: $t('allerts.close'),
          confirm: $t('allerts.confirm'),
          loading: $t('allerts.loading'),
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from "../../elements/index/indexTable.vue";

export default {
  data() {
    return {
      path: "/partnersProfits",
    };
  },
  components: {
    indexTable,
  },
};
</script>
